import { Injectable } from '@angular/core'
import { FormGroup, Validators, FormBuilder } from '@angular/forms'
import { ValidationService } from '@app/shared/services/validation.service'
import { TelephoneNameFormService } from '@app/modules/telephone-name/telephone-name-form.service'
import { Telephone } from '@app/modules/telephone/telephone.model'

@Injectable()

export class TelephoneFormService {

  /**
   * Insert vaildators
   */
  public insertValidators: Array<any> = [
    {
      telephoneNameUuid: [
        Validators.required,
        ValidationService.isUuid
      ]
    },
    {
      number: [
        ValidationService.noWhiteSpace,
        ValidationService.noEmojis,
        Validators.maxLength(191),
        Validators.required
      ]
    },
    {
      extension: [
        ValidationService.noWhiteSpace,
        ValidationService.noEmojis,
        Validators.maxLength(191)
      ]
    },
    {
      iso2: [
        ValidationService.noWhiteSpace,
        ValidationService.noEmojis,
        Validators.minLength(2),
        Validators.maxLength(2)
      ]
    }
  ]

  /**
   * Update validators
   */
  public updateValidators: Array<any> = [
    {
      uuid: [
        Validators.required,
        ValidationService.isUuid
      ]
    }
  ]

  /**
   * Constructor
   */
  public constructor (
    private formBuilder: FormBuilder,
    public validationService: ValidationService,
    private telephoneNameFormService: TelephoneNameFormService
  ) {}

  /**
   * Get form
   */
  public getForm (telephone: Telephone, type: string): FormGroup {
    const form: FormGroup = this.formBuilder.group({
      uuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      telephoneNameUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      number: [
        null,
        [
          ValidationService.noWhiteSpace,
          ValidationService.noEmojis,
          Validators.maxLength(191)
        ]
      ],
      extension: [
        null,
        [
          ValidationService.noWhiteSpace,
          ValidationService.noEmojis,
          Validators.maxLength(191)
        ]
      ],
      iso2: [
        null,
        [
          ValidationService.noWhiteSpace,
          ValidationService.noEmojis,
          Validators.minLength(2),
          Validators.maxLength(2)
        ]
      ],
      // Info.
      createdAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      updatedAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      deletedAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      createdByUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      updatedByUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ]
    })

    if (type === 'new') {
      this.validationService.addInsertValidators(form, this.insertValidators)
    }

    if (type === 'edit') {
      this.validationService.addUpdateValidators(form, this.insertValidators, this.updateValidators)
    }

    if (telephone.telephoneName) {
      form.addControl('telephoneName', this.telephoneNameFormService.getForm(telephone.telephoneName, ''))
    }

    if (telephone) {
      form.patchValue(telephone, { emitEvent: false })
    }

    return form
  }

}
